module.exports = __webpack_public_path__ + "static/media/img.default.645366b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/components/AppCard/img.default.svg
// module id = 2110
// module chunks = 0